import { connect } from 'react-redux';
import { setTimeZone } from '../../../actions/settings';
import dayjs from '../../../../dayjs/dayjs_timezone';
import { customSelectStyles } from '../../../utilities/helperUtility';
import TimeZone from './TimeZone';

export default connect(
  ({
    order = {},
    product = {},
    settings = {},
  }) => ({
    ...settings,
    locations: product.data ? product.data.locations : [],
    selectedLocation: order.selectedLocation || null,
    timeZones: settings.timeZones || [],
    styles: settings.style || {},
    selectStyles: customSelectStyles(settings.style.select),
    localTimeZone: dayjs.tz.guess(),
  }),
  (dispatch) => ({
    setTimeZone: (value) => dispatch(setTimeZone(value)),
  }),
)(TimeZone);
